import NoDataText from "../../../../components/emptyState/emptyStateText";
import Tel1Summary from "./summary";
function Tel1Fasilitator({ summaryData = [] }) {
  return (
    <>
      <div className="d-flex mb-3">
        <div className="flex-1 d-flex flex-column">
          <div>Pembicara/Instructor/Fasilitator</div>
          {summaryData.length > 0 ? (
            summaryData.map((fasilitator, index) => (
              <div key={index}>
                <div>{fasilitator.instructorName} :</div>
                <Tel1Summary summaryData={fasilitator.result} />
              </div>
            ))
          ) : (
            <NoDataText />
          )}
        </div>
      </div>
    </>
  );
}

export default Tel1Fasilitator;
